import React from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import MyButton from '@components/MyButton';
import { useNavigate } from 'react-router-dom';
import useEmployee from '@hooks/useEmployee';
import { Employee } from '@models/Models';


const AddEmployee = () => {
    const navi = useNavigate();
    const { createEmployee } = useEmployee();
    const { register, getValues } = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            phone: ""
        }
    });

    const handleSubmit = async () => {
        const { firstName, lastName, email, phone } = getValues();

        const newEmployee: Partial<Employee> = {
            firstName,
            lastName,
            email,
            phone,
            status: "active",
        };

        const createEmployeeResult = await createEmployee(newEmployee);

        if(!createEmployeeResult.success) {
            alert("Fehler beim Hinzufügen des Mitarbeiters.");
            return;
        };
        navi("/mitarbeiter");
    }

    return (
        <Container className='myCont'>
            <h1>Mitarbeiter hinzufügen</h1>
            <Row className='my-3'>
                <Col>
                    <Form.Group>
                        <Form.Label>Vorname</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Vorname"
                            {...register("firstName")}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Nachname</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Nachname"
                            {...register("lastName")}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Email"
                            {...register("email")}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Handynummer</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Handynummer"
                            {...register("phone")}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col className='d-flex justify-content-end gap-3'>
                    <MyButton
                        title='Zurück'
                        disabled={false}
                        isSecundary={true}
                        onClick={() => navi("/")}
                    />
                    <MyButton
                        title='Weiter'
                        disabled={false}
                        isSecundary={false}
                        onClick={handleSubmit}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default AddEmployee